import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomValidationService } from 'app/main/apps/shared/services/util/customvalidation.service';

@Component({
  selector: 'app-dialog-cambiar-clave',
  templateUrl: './dialog-cambiar-clave.component.html',
  styleUrls: ['./dialog-cambiar-clave.component.scss']
})
export class DialogCambiarClaveComponent implements OnInit {
  formulario: FormGroup;
  constructor(
    private customValidator: CustomValidationService,
    public dialogRef: MatDialogRef<DialogCambiarClaveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.formulario = this.fb.group({
        clave1: [, { validators: [Validators.required,this.customValidator.patternValidator()] }],
        clave2: [, { validators: [Validators.required] }]
    },
    {
      validator: this.customValidator.MatchPassword('clave1', 'clave2'),
    });
  }



  get clave1() {
    return this.formulario.get("clave1");
  }

  get clave2() {
    return this.formulario.get("clave2");
  }

}
